export default `
§ sidebar.switch.team: Das Team
§ sidebar.switch.person: Der Angestellte
§ sidebar.buttons.settings: Die Einstellungen
§ sidebar.buttons.print: Drucken
§ sidebar.buttons.share: Share
§ sidebar.buttons.logout: Logout
§ sidebar.filters.all: Die ganze Zeit
§ sidebar.filters.year: Jahr
§ sidebar.filters.halfYear: ein halbes Jahr
§ sidebar.filters.month: Monat
§ sidebar.filters.week: die Woche
§ sidebar.team.total: Allgemeine Informationen
§ sidebar.team.scope: Module
§ sidebar.team.author: Mitarbeiter
§ sidebar.team.type: Aufgabentypen
§ sidebar.team.pr: Code einfüllen
§ sidebar.team.day: Tageweise
§ sidebar.team.week: Nach Wochen
§ sidebar.team.month: Nach Monaten
§ sidebar.team.tree: Dateien
§ sidebar.team.removedTree: Gelöschte dateien
§ sidebar.team.files: Dateien
§ sidebar.team.removedFiles: Gelöschte Dateien
§ sidebar.team.extension: Extensions
§ sidebar.team.tasks: Aufgabenliste
§ sidebar.team.release: Releases
§ sidebar.team.hours: Zeitplan
§ sidebar.team.commits: All commits
§ sidebar.team.changes: Alle Änderungen
§ sidebar.team.words: Beliebte Wörter
§ sidebar.team.building: Quiz
§ sidebar.team.refactor: Refactoring
§ sidebar.team.company: Companies
§ sidebar.team.country: Locations
§ sidebar.team.settings: Die Einstellungen
§ sidebar.person.total: Allgemeine Informationen
§ sidebar.person.money: Arbeitskosten
§ sidebar.person.speed: Geschwindigkeit
§ sidebar.person.day: Tageweise
§ sidebar.person.week: Nach Wochen
§ sidebar.person.month: Nach Monaten
§ sidebar.person.tasks: Tasks
§ sidebar.person.hours: Zeitplan
§ sidebar.person.commits: All commits
§ sidebar.person.changes: Alle Änderungen
§ sidebar.person.words: Beliebte Wörter
§ sidebar.person.settings: Die Einstellungen
`;
